import { render } from "./NotificationParentEditPane.vue?vue&type=template&id=5dc9af71&scoped=true&ts=true"
import script from "./NotificationParentEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationParentEditPane.vue?vue&type=script&lang=ts"

import "./NotificationParentEditPane.vue?vue&type=style&index=0&id=5dc9af71&lang=css"
import "./NotificationParentEditPane.vue?vue&type=style&index=1&id=5dc9af71&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc9af71"]])

export default __exports__